import { useState } from 'react';
import { message, notification } from 'antd';
import { importStudents, importTeachers } from '../../../services/importService';
import { TeacherImportResult } from '../../../types/importTypes';

export function useTeacherImport() {
  const [open, setOpen] = useState(false);
  const [csvFile, setCsvFile] = useState<File | null>(null);
  const [loading, setLoading] = useState(false);
  const [importResult, setImportResult] = useState<TeacherImportResult | null>(null);

  const handleUpload = (file: File) => {
    setCsvFile(file);
    return false;
  };

  const handleSubmit = async (t: any) => {
    if (!csvFile) return;
    setLoading(true);

    try {
      const result = await importTeachers({ file: csvFile });
      setImportResult(result);
      message.success(t('import_teacher_success'));
    } catch {
      message.error(t('import_teacher_error'));
    } finally {
      setLoading(false);
    }
  };

  const reset = () => {
    setCsvFile(null);
    setImportResult(null);
  };

  return {
    open,
    setOpen,
    csvFile,
    setCsvFile,
    loading,
    importResult,
    handleUpload,
    handleSubmit,
    reset,
  };
}
